import { render } from "./CtaOne.vue?vue&type=template&id=6c74dc0e&scoped=true"
import script from "./CtaOne.vue?vue&type=script&lang=js"
export * from "./CtaOne.vue?vue&type=script&lang=js"

import "./CtaOne.vue?vue&type=style&index=0&id=6c74dc0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c74dc0e"]])

export default __exports__